class ProductDimentions {
    width = 0.0;
    height = 0.0;
    length = 0.0;

    constructor(width = 0.0, height = 0.0, length = 0.0) {
        this.width = width;
        this.height = height;
        this.length = length;
    }

    toDto = () => {
        return {
            width: this.width,
            height: this.height,
            length: this.length,
        };
    }
};

export default ProductDimentions;